import { fetch } from '@/shared/fetch';

export const setIsBabyBorn = async (isBabyBorn: boolean): Promise<void> => {
    await fetch<void>('/api/newborn/is-baby-born', 'POST', isBabyBorn);
};
